export const SORT_DIRECTIONS = {
  ASC: 'asc',
  DESC: 'desc',
  NONE: 'none',
};

export const SORT_LABEL_ALIGNMENT = {
  LEFT: 'flex-start',
  CENTER: 'center',
  RIGHT: 'flex-end',
};
